module.exports = __webpack_public_path__ + "img/bandera_espana.79d85e15.svg";